import {reaction} from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {Disposers, ReactNodeGenerator} from '../../../../../lib/helpers';
import {AddContentStore} from '../../../x7/content-parts/AddContentStore';
import {MQDataPairComponent} from './parts/MQDataPairComponent';
import {MQOptionsComponent} from './parts/MQOptionsComponent';
import {MQEditStore} from './stores/MQEditStore';

function* renderer(store: MQEditStore): ReactNodeGenerator {
  const swappable = store.options.leftSide.value === 'text';
  yield (
    <MQOptionsComponent key="matching-question-options"
                        store={store.options}>
      <button type="button" className="btn btn-primary"
              disabled={!swappable}
              onClick={store.swapLeftAndRight}>
        Swap
      </button>
      <button type="button" className="btn btn-primary"
              onClick={store.addPair}>
        Add
      </button>
    </MQOptionsComponent>);

  const options = store.options.options;
  for (let index = 0; index < store.dataPairs.length; index++) {
    let dataPair = store.dataPairs[index];
    yield (
      <MQDataPairComponent key={'data-pair-' + index}
                           options={options}
                           store={dataPair}>
        <button type="button" className="btn btn-primary" onClick={() => store.removePair(index)}>
          Remove
        </button>
      </MQDataPairComponent>);
  }
}

@observer
export class X9MatchingQuestionCreate extends React.Component<{ store: AddContentStore }> {
  readonly store: MQEditStore;
  disposers: Disposers;

  constructor(props: Readonly<{ store: AddContentStore }>) {
    super(props);
    this.store = new MQEditStore();
    this.disposers = new Disposers();
    this.disposers.add(this.store);
    this.setup();
  }

  setup() {
    this.disposers.add(
      reaction(
        () => this.store.valid,
        (valid) => this.props.store.setValid(valid),
        {fireImmediately: true}),
      reaction(
        () => this.store.x9Contents,
        (contents) => this.props.store.setContents(contents),
        {fireImmediately: true}));
  }

  render() {
    const store = this.store;

    return (Array.from(renderer(store)));
  }

  componentWillUnmount() {
    this.disposers.dispose();
  }
}
